<script setup>
import { router, Head, Link, useForm } from '@inertiajs/vue3';
import JetButton from '@/Jetstream/Button.vue';
import JetInput from '@/Jetstream/Input.vue';
import JetCheckbox from '@/Jetstream/Checkbox.vue';
import JetLabel from '@/Jetstream/Label.vue';
import JetValidationErrors from '@/Jetstream/ValidationErrors.vue';
import JetReportingHeader from '@/Jetstream/ReportingHeader.vue';
import JetApplicationFooter from '@/Jetstream/ApplicationFooter.vue';
import JetWelcomePanel from '@/Jetstream/WelcomePanel.vue';
import AppTheming from '@/Jetstream/AppTheming.vue';

defineProps({
    status: String,
});

const form = useForm({
    email: '',
    errors: '',
    success: '',
});

const submit = () => {

    // Clear previous success message and errors on submit
    form.success = '';  // Reset the success message
    form.errors = '';   // Reset any errors

    let slugs = { 'subdomain': 'reporting' };

    form.transform(data => ({
        ...data,
        subdomain: 'reporting',  // Add the subdomain to the form data
    }))
    .post(route('reporting.reset-password-request', slugs), {
        onSuccess: () => {
            form.success = 'Reset request submitted successfully.';  // Set success message
            form.errors = '';  // Clear errors if any present
        },
        onError: (errors) => {
            form.errors = errors;  // Handle validation errors from the backend
        }
    });
};

</script>

<template>

    <AppTheming />

    <Head title="Forgot Password" />

    <JetReportingHeader />

    <div id="content-wrapper">


        <div id="main-content" class="container mx-auto flex flex-col md:flex-row justify-center w-full pt-5 pb-5">

                <div class="card sos-programme-form-card sos-reporting-form-card p-10 rounded-2xl mt-10">

                    <div class="mb-4 manage-password">
                        {{ $t('reporting.password_reset.password_reset_title') }}
                    </div>

                    <div v-if="form.success" class="mb-4 font-bold">
                         {{ form.success }}
                    </div>

                    <JetValidationErrors class="mb-4"/>
                    <JetInputError :message="form.errors.email ? form.errors.email[0] :''" class="mb-4 col error"/>

                    <form @submit.prevent="submit">
                        <div>
                            <JetLabel for="email" :value="$t('reporting.login.email')" />
                            <JetInput
                                id="email"
                                v-model="form.email"
                                type="email"
                                class="mt-1 block w-full"
                                required
                                autofocus
                            />
                        </div>

                        <div class="flex items-center justify-end mt-4">
                            <Link :href="route('reporting.login', { subdomain: 'reporting' })" class="mr-4 text-sm text-gray-600 underline hover:text-gray-900">
                                {{ $t('reporting.password_reset.log_in') }}
                            </Link>
                            <JetButton :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                                {{ $t('reporting.password_reset.request_password_reset') }}
                            </JetButton>
                        </div>
                    </form>
                </div>
        </div>
     </div>

</template>
